import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiLinkedin, FiTwitter, FiMail, FiHeart } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Deepak Chauhan</h3>
            <p>Software Developer specializing in .NET, Blazor, and modern web technologies.</p>
            <div className="footer-social">
              <a href="https://github.com/Deep5181" target="_blank" rel="noreferrer" className="social-link">
                <FiGithub size={20} />
              </a>
              <a href="https://www.linkedin.com/in/deepak-chauhan-03b0b622b/" target="_blank" rel="noreferrer" className="social-link">
                <FiLinkedin size={20} />
              </a>
              <a href="https://twitter.com/deepakchauhan" target="_blank" rel="noreferrer" className="social-link">
                <FiTwitter size={20} />
              </a>
              <a href="mailto:dc9958211@gmail.com" className="social-link">
                <FiMail size={20} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/resume">Resume</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-links">
            <h4>Services</h4>
            <span>Web Development</span>
            <span>Full Stack Solutions</span>
            <span>Broadcast Automation</span>
            <span>Consulting</span>
          </div>

          <div className="footer-contact-info">
            <h4>Get In Touch</h4>
            <p>Available for freelance projects and full-time opportunities.</p>
            <Link to="/contact" className="btn btn-primary">Contact Me</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Deepak Chauhan. Built with <FiHeart size={14} color="#e74c3c" /> using React &amp; .NET</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
